<i18n>
{
"en": {
  "MESSAGES": "Messages",
  "DETAILS": "Details",
  "LOADING": "Loading...",
  "SCHOOL": "School",
  "VIOLATION": "Violation",
  "NODATA": "No Data",
  "STATUS": "Status",
  "STUDENT": "Student",
  "VIEWMORE": "View More",
  "STUDENTS": "Students",
  "BUSSUPERVISOR": "Bus Supervisor",
  "INCIDENTS": "Incidents",
  "BUSVIOLATIONSANDALARMS": "Bus Violations And Alarms",
  "NOMORERECORDS": "No more records",
  "FIRSTSTOP": "First Stop",
  "NEXTSTOP": "Next Stop",
  "LASTSTOP": "Last Stop",
  "NOMORESTOPS": "No More Stops",
  "MINUTES": "Minutes",
  "TRIPCLOSED": "Trip Closed",
  "RESOLVED": "Resolved",
  "REPORTED": "Reported",
  "OPEN": "Open",
  "BUSTRIPS": "Bus Trips",
  "ROUTE": "Route",
  "BUS": "Bus",
  "STICK": "Stick",
  "UNSTICK": "Unstick",
  "SHOW": "Show",
  "HIDE": "Hide",
  "VIEWINCIDENTDETAILS": "View Incident Details",
  "WRITEAMESSAGE": "Write a Message",
  "violation_video_loss": "Lost video signal",
  "violation_motion_detection": "Motion detected",
  "violation_blind": "Camera {pos} is blind",
  "violation_storage": "Storage error @3 on disk @1",
  "violation_user_1": "Smoke detected",  
  "violation_user_2": "Airflow-Sensor",
  "violation_user_3": "Inner Temperature",
  "violation_user_4": "Inner Humidity",
  "violation_user_5": "Bus stalled",
  "violation_user_6": "User alarm 6",
  "violation_user_7": "User alarm 7",
  "violation_user_8": "User alarm 8",
  "violation_user_9": "User alarm 9",
  "violation_user_10": "User alarm 10",
  "violation_emergency": "Panic button pressed",
  "violation_low_speed": "Low speed alarm (@1 km/h)",
  "violation_high_speed": "High speed alarm (@1 km/h)",
  "violation_low_voltage": "Low voltage (@1 v)",
  "violation_acceleration": "Acceleration alarm @1",
  "violation_header": "Service Level Agreement Violations and Alarms",
  "violation_inspection_failed": "Red Button Not Pressed",
  "violation_firealarm_release": "Smoke detector off",
  "violation_stop_buttom_pressed": "Stop Button Pressed",
  "violation_stop_buttom_released": "Stop Button Released",
  "SECONDSAGO": "{var} seconds ago",
  "ONEMINUTEAGO": "one minute ago",
  "MINUTESAGO": "{var} minutes ago",
  "ANHOURAGO": "an hour ago",
  "HOURSAGO": "{var} hours ago",
  "YESTERDAY": "yesterday",
  "DAYSAGO": "{var} days ago",
  "AWEEKAGO": "a week ago",
  "WEEKSAGO": "{var} weeks ago",
  "AMONTHAGO": "a month ago",
  "MONTHSAGO": "{var} months ago",
  "ONEYEARAGO": "one year ago",
  "YEARSAGO": "{var} years ago",
  "NOW": "just now",
  "NAME": "Name",
  "PICK-UP/DROP-OFF": "Pick-up/Drop-off",
  "SCHOOLANDBUSABSENCES": "School and Bus Absences",
  "REASON": "Reason",
  "SICKNESS": "Sickness",
  "VACATION": "Vacation",
  "EMERGENCY": "Emergency",
  "PERSONAL": "Personal",
  "MORNINGBUS": "Morning Bus",
  "AFTERNOONBUS": "Afternoon Bus",
  "NOBUS": "No Bus",
  "DATE": "Date",
  "BUS": "Bus",
  "SWITCHTOABSENCES": "Switch to {var} Absences",
  "STARTEDAT": "Started at",
  "CLOSEDAT": "Closed at",
  "NOTCLOSINGYET": "Not closing yet",
  "EXPECTEDTOSTART": "Expected To Start..",
  "DELAYED": "Delayed",
  "DURATION": "Duration",
  "STANDING": "Standing",
  "MISSED": "Missed",
  "WRONGPLACE": "Wrong Place",
  "NOVIOLATIONS": "No Violations",
  "TRIPVIOLATIONS": "Trip Violations",
  "TRIPALERTS": "Trip Alerts",
  "NOALERTS": "No Alerts",
  "OCCURED": "Occured",
  "TYPE": "Type",
  "MESSAGE": "Message",
  "MOREINFO": "More Info",
  "DELAYEDBY": "Delayed by:",
  "HOUR": "hour | hours",
  "MINUTE": "minute | minutes",
  "ALERT": "Alert",
  "INCIDENT": "Incident",
  "VIEWALERTS": "View Alerts",
  "VIEWINCIDENTS": "View Incidents",
  "CHILDBEHAVIOUR": "Child Behaviour",
  "MEDICAL": "Medical",
  "DRIVERISSUE": "Driver Issue",
  "BUSPROBLEM": "Bus Problem",
  "ACCIDENT": "Accident",
  "TRAFFIC": "Traffic",
  "CALLPOLICE": "Call Police",
  "CALLSCHOOL": "Call School",
  "OTHER": "Other",
  "ACTIVE": "Active",
  "SWITCHTO": "Switch to {var} Trips",
  "VIEWVIOLATIONS": "View Violations",
  "FUELCOST": "Fuel cost is",
  "TOTALCOST": "Total cost is",
  "IDLECOST": "Idle cost is",
  "AED": "AED",
  "REPORTEDBY": "Reported-By",
  "GUARDIAN": "Guardian",
  "NAANI": "Supervisor"
},
"ar": {
   "MESSAGES": " رسائل",
   "DETAILS": "تفاصيل",
   "LOADING": "جار التحميل...",
   "SCHOOL": "مدرسة",
   "VIOLATION": "مخالفة",
   "NODATA": "لا توجد بيانات",
   "STATUS": "الحالة",
   "STUDENT": " الطالب",
   "VIEWMORE": "مشاهدة المزيد",
   "STUDENTS": "الطلاب",
   "BUSSUPERVISOR": "مشرفة الحافلة",
   "INCIDENTS": "حوادث",
   "BUSVIOLATIONSANDALARMS": "مخالفات وانذارات الحافلة",
   "NOMORERECORDS": "لا مزيد من السجلات",
   "FIRSTSTOP": "المحطة الأولى",
   "NEXTSTOP": "المحطة التالية",
   "LASTSTOP": " المحطة الأخيرة",
   "NOMORESTOPS": "لا توجد أي محطة",
   "MINUTES": "الدقائق",
   "TRIPCLOSED": "أغلقت الرحلة",
   "RESOLVED": " حل",
   "REPORTED": "ذكرت",
   "OPEN": "فتح",
   "BUSTRIPS": "الرحلات",
   "ROUTE": "الرحلة",
   "BUS": "الحافلة",
   "WRITEAMESSAGE": "اطبع الرسالة",
   "STICK": "لصق",
   "UNSTICK": "فك",
   "SHOW": "تبين",
   "HIDE": "إخفاء",   
   "VIEWINCIDENTDETAILS": "عرض تفاصيل الحادث",
   "WRITEAMESSAGE": "اكتب رسالة",
  "violation_video_loss": "فقدت إشارة الفيديو",
  "violation_motion_detection": "تم اكتشاف حركة",
  "violation_blind": "عمياء {POS } الكاميرا",
  "violation_storage": "خطأ في التخزين @ 3 على القرص @ 1",
  "violation_user_1": "تم الكشف عن الدخان",  
  "violation_user_2": "  استشعار تدفق الهواء ",
  "violation_user_3": "درجة الحرارة الداخلية",
  "violation_user_4": "الرطوبة الداخلية",
  "violation_user_5": "توقفت الحافلة ",
  "violation_user_6": " 6 تنبيه المستخدم ",
  "violation_user_7": "7 تنبيه المستخدم",
  "violation_user_8": "8 تنبيه المستخدم",
  "violation_user_9": " 9 تنبيه المستخدم",
  "violation_user_10": " 10 تنبيه المستخدم",
  "violation_emergency": "تم الضغط على زر الهلع",
  "violation_low_speed":  "إنذار انخفاض السرعة (@ 1 كم / ساعة)",
  "violation_high_speed": "إنذار ارتفاع السرعة (@ 1 كم / ساعة)",
  "violation_low_voltage": "V انخفاض الجهد (@ 1)",
  "violation_acceleration": "1 @ تنبيه السرعة",
  "violation_header": "اتفاقية مستوى الخدمة الانتهاكات والإنذارات",
  "violation_inspection_failed": "زر أحمر لم تضغط",
  "violation_firealarm_release": "Smoke detector off",
  "violation_stop_buttom_pressed": "Stop Button Pressed",
  "violation_stop_buttom_released": "Stop Button Released",
  "SECONDSAGO": " منذ {var} ثوانى",
  "ONEMINUTEAGO": "قبل دقيقة واحدة",
  "MINUTESAGO": "مضت {var} دقائق",
  "ANHOURAGO": "قبل ساعة",
  "HOURSAGO": " منذ {var} ساعات",
  "YESTERDAY": "في الامس",
  "DAYSAGO": "مضت {var} أيام",
  "AWEEKAGO": "منذ أسبوع",
  "WEEKSAGO": "منذ  {var} أسابيع",
  "AMONTHAGO": "قبل شهر",
  "MONTHSAGO": "منذ {var} اشهر",
  "ONEYEARAGO": "قبل عام واحد",
  "YEARSAGO": "مضت {var} سنين",
  "NOW": "الآن",
  "NAME": "الاسم",
  "PICK-UP/DROP-OFF": "حمل / نزل الطلاب",
  "SCHOOLANDBUSABSENCES": "غياب المدرسة والحافلات",
  "REASON": "السبب",
  "SICKNESS": "المرض",
  "VACATION": "الاجازة",
  "EMERGENCY": "حالة طوارق",
  "PERSONAL": "اسباب شخصية",
  "MORNINGBUS": "حافلة الصباح",
  "AFTERNOONBUS": "حافلة المساء",
  "NOBUS": "لا يوجد اي حافلة",
  "DATE": "التاريخ",
  "SCHOOL": "المدرسة",
  "SWITCHTOABSENCES": "التبديل إلى {var} غياب",
  "STARTEDAT": "بدأت في",
  "CLOSEDAT": "مغلق في",
  "NOTCLOSINGYET": "لم يتم الإغلاق بعد",
  "EXPECTEDTOSTART": "...من المتوقع البدء ",
  "DELAYED": "مؤجل",
  "DURATION": "المدة الزمنية",
  "STANDING": "واقفا",
  "MISSED": "مفقود",
  "WRONGPLACE": "المكان الخطأ",
  "NOVIOLATIONS": "لا توجد انتهاكات",
  "TRIPVIOLATIONS": "انتهاكات الرحلة",
  "TRIPALERTS": "تنبيهات الرحلة",
  "NOALERTS": "لا توجد تنبيهات",
  "EVENT": "حدث",
  "TYPE": "نوع",
  "MESSAGE": "رسالة",
  "MOREINFO": "معلومات اكثر",
  "DELAYEDBY": ":تأخر",
  "HOUR": "ساعة | ساعات",
  "MINUTE": "دقيقة | دقائق",
  "ALERT": "إنذار",
  "INCIDENT": "حادث",
  "CHILDBEHAVIOUR": "سلوك الطفل",
  "MEDICAL": " طبي",
  "DRIVERISSUE": "مشكلة السائق",
  "BUSPROBLEM": "مشكلة الحافلة",
  "ACCIDENT": "حادث",
  "TRAFFIC": "حركة المرور",
  "CALLPOLICE": "اتصل بالشرطة",
  "CALLSCHOOL": "اتصل بالمدرسة",
  "OTHER": "آخر",
  "VIEWALERTS": "عرض التنبيهات",
  "VIEWINCIDENTS": "عرض الحوادث",
  "OCCURED": "حدث",
  "DELAYED": "مؤجلة",
  "SWITCHTOABSENCES": "التبديل إلى {var} الرحلات",
  "VIEWVIOLATIONS": "عرض الانتهاكات",
  "FUELCOST": "تكلفة السفر هو",
  "TOTALCOST": "تكلفة صيانة المركبات هي",
  "IDLECOST": "تكلفة الوقت الضائع",
  "AED": "درهم",
  "REPORTEDBY": "تم عمل تقرير بواسطة",
  "GUARDIAN": "ولي الامر",
  "NAANI": "مشرفة"
}
}
</i18n>
<template>
  <div class="dashboard">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-card class="box-card message" height="335" :body-style="{ padding: '0px' }">
          <div slot="header" class="clearfix">
            <span style="line-height: 36px;"><i class="fa fa-envelope"></i> {{$t('MESSAGES')}}</span>
            <el-tooltip v-if="isAllowed('send', 'report/message')" :content="$t('WRITEAMESSAGE')" placement="top">
              <el-button @click="messageBox=true" type="text"><i class="fa fa-comment fa-2x"></i> </el-button>
            </el-tooltip>            
          </div>
          <el-table
            v-loading="message_loading"
            :element-loading-text="$t('LOADING')"
            :data="listMessages"
            @current-change="selectedConversation"
            row-class-name="pointer-hover"
            :height="340"
            stripe
            style="width: 100%">
            <el-table-column
            >
              <template slot-scope="scope">
                <div class="media">
                  <div class="media-left">
                    <img class="img-circle" style="width: 50px" :src="getAsset(scope.row.monitor.ImagePath, 'supervisor')" />
                  </div>
                  <div class="media-body">
                      {{_FullName({NameEN: scope.row.monitor.FullName_EN, NameAR: scope.row.monitor.FullName_AR})}}
                      <br/>
                      <small>{{(scope.row.time_ago.split(' ').length === 1) ? $t(scope.row.time_ago.split(' ')[0]) : $t(scope.row.time_ago.split(' ')[1], {var: scope.row.time_ago.split(' ')[0]})}}</small>
               
                      <br/>
                      {{readMore(scope.row.Text)}}
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div style="padding: 10px;">
            <div class="bottom clearfix">
              <el-button type="primary" :disabled="!isAllowed('index', 'report/message')" @click="viewMore('message')">{{$t('VIEWMORE')}}</el-button>
            </div>
          </div>
        </el-card>
        <el-card  class="box-card violation" height="335" :body-style="{ padding: '0px' }">
          <div slot="header" class="clearfix">
            <span style="line-height: 36px;"><i :class="'fa ' + (wiot_box==1 ? 'fa-tachometer' : 'fa-user-times')"></i> {{$t(wiot_box!=1 ? 'SCHOOLANDBUSABSENCES' : 'BUSVIOLATIONSANDALARMS')}}</span>
            <el-tooltip v-if="wiot_box!=1" :content="$t('SWITCHTOABSENCES', {var : $t(absenceFrom=='bus' ? 'SCHOOL' : 'BUS')})" placement="top">
            <el-button  v-on:click="switchTo()">
              <i class="fa" v-bind:class="[absenceFrom!=='bus' ? 'fa-university' : 'fa-bus']"></i>
              <span v-text="absenceFrom!=='bus' ? $t('SCHOOL') : $t('BUS')"></span>
            </el-button> 
            </el-tooltip>     
          </div>
    <div v-if="wiot_box!=1">
      
    <el-table

        :element-loading-text="$t('LOADING')"
        :data="listAbsences"
        @row-click="showAbsence"
        v-loading="absence_loading"
        row-class-name="pointer-hover"
        highlight-current-row
        :height="340"
        style="overflow:hidden"
        stripe
        >

        <el-table-column
          :label="$t('NAME')"
          min-width="175"
          align="left"
        >
          <template slot-scope="scope">
            <img :src="getAsset(scope.row.ImagePath, 'student')" alt="" class="img-circle" style="width: 49px; float: left;">
            {{_FullName({NameEN: scope.row.FullName_EN, NameAR: scope.row.FullName_AR})}}

          </template>
        </el-table-column>

        <el-table-column
          :label="$t('DATE')"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span v-text="date_format(scope.row.AbsentDate)"></span>
          </template>
        </el-table-column>

        <el-table-column
          :label="$t(absenceFrom=='bus' ? 'PICK-UP/DROP-OFF' : 'REASON')"
          align="center"
          min-width="150"
         >
          <template slot-scope="scope">
            {{(absenceFrom=='bus' ? $t(scope.row.Direction.title) : $t(scope.row.Reason.toUpperCase()))}}
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('REPORTEDBY')"
          align="center"
          min-width="100"
         >
          <template slot-scope="scope">
            <el-tag type="primary">{{$t(scope.row.ReportedBy)}}</el-tag>
          </template>
        </el-table-column>        
      </el-table>
    </div>
    
          <el-table
            v-if="wiot_box==1"
            :data="violations"
            v-loading="violation_loading"
            :element-loading-text="$t('LOADING')"
            :height="340"
            stripe
            >
            <el-table-column
              prop="bus_plate"
              :label="$t('BUS')" min-width="100">
              <template slot-scope="scope">
                {{scope.row.busNumber}}<br/><small>{{scope.row.datetime}}</small>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('VIOLATION')" min-width="200">
              <template slot-scope="scope">
                {{$t(scope.row.Label)}}
              </template>
            </el-table-column>
            <el-table-column min-width="100" align="right">
              <template slot-scope="scope">
              <el-tooltip :content="scope.row.IsSticky ? $t('UNSTICK') : $t('STICK')" placement="top">
                <el-button v-if="isAllowed('flag', 'report/violation')" type="text" @click="flagItem(scope.row, scope.$index, 'violation')"><i class="fa" :class="[scope.row.IsSticky ? 'fa-flag text-danger' : 'fa-flag-o']" ></i></el-button>
              </el-tooltip>
              <el-tooltip :content="scope.row.IsHidden ? $t('SHOW') : $t('HIDE')" placement="top">
                <el-button v-if="isAllowed('flag', 'report/violation')" type="text" @click="hideItem(scope.row, scope.$index, 'violation')"><i class="fa" :class="[scope.row.IsHidden ? 'fa-eye-slash' : 'fa-eye']" ></i></el-button>
              </el-tooltip>                 
              </template>
            </el-table-column>
        </el-table>
                          <div style="padding: 10px;">
                            <div class="bottom clearfix">
                              <el-button type="primary"  :disabled="!isAllowed('index', wiot_box ==1 ? 'report/violation' : 'attendance/absence')"  @click="viewMore(wiot_box ==1 ? 'violation' : 'absence')">{{$t('VIEWMORE')}}</el-button>
                            </div>
                          </div>
                        </el-card>
                      </el-col>

                      <el-col :span="12">
                        <el-card class="box-card incident" :height="335" :body-style="{ padding: '0px' }">
                              <div slot="header" class="clearfix">
                                  <span style="line-height: 36px;"><i class="fa fa-exclamation-triangle"></i> {{$t('INCIDENTS')}}</span>
                              </div>

                              <el-table
                                      v-loading="incident_loading"
                                      :element-loading-text="$t('LOADING')"
                                      :data="incidents"
                                      :height="340"
                                      stripe
                                      style="width: 100%;">
                                  <el-table-column
                                    min-width="150"
                                    :label="$t('BUSSUPERVISOR')"
                                  >
                                      <template slot-scope="scope">
                                       {{_FullName({NameEN: scope.row.monitor.FullName_EN, NameAR: scope.row.monitor.FullName_AR})}}<br /><small>{{incident_date(scope.row.Timestamp)}}</small>
                                      </template>
                                  </el-table-column>
                                  <el-table-column
                                          :label="$t('STUDENTS')"
                                          min-width="100"
                                          align="center">
                                      <template slot-scope="scope">
                                          {{scope.row.student_id.length}}
                                      </template>
                                  </el-table-column>

                                  <el-table-column
                                          :label="$t('STATUS')"
                                          min-width="120"
                                  >
                                      <template slot-scope="scope">
                                          <el-tag v-bind:type="status[scope.row.statusColor]">
                                              {{reportStatus[scope.row.statusColor]}}
                                          </el-tag>
                                      </template>
                                  </el-table-column>
                                  <el-table-column min-width="130">
                                      <template slot-scope="scope">
                                        <el-tooltip :content="$t('VIEWINCIDENTDETAILS')" placement="top">
                                          <el-button  type="small" @click="showIncident(scope.row)"><i class="fa fa-info-circle"></i> {{$t('DETAILS')}}</el-button>
                                        </el-tooltip>                                          
                                      </template>
                                  </el-table-column>



                                  <el-table-column align="right" min-width="50">
                                      <template slot-scope="scope">
                                      <el-tooltip :content="scope.row.IsSticky ? $t('UNSTICK') : $t('STICK')" placement="top">
                                        <el-button v-if="isAllowed('flag', 'report/incident')" type="text" @click="flagItem(scope.row, scope.$index, 'incident')"><i class="fa" :class="[scope.row.IsSticky ? 'fa-flag text-danger' : 'fa-flag-o']" ></i></el-button>
                                      </el-tooltip>                                        
                                      </template>
                                  </el-table-column>
                              </el-table>
                              <div style="padding: 10px;">
                                  <div class="bottom clearfix">
                                      <el-button type="primary" :disabled="!isAllowed('index', 'report/incident')" @click="viewMore('incident')">{{$t('VIEWMORE')}}</el-button>
                                  </div>
                              </div>
                          </el-card>
                        <el-card class="box-card transport" :body-style="{ padding: 0 }">
                          <div slot="header" class="clearfix">
                            <span style="line-height: 36px;"><i class="fa fa-bus"></i> {{$t('BUSTRIPS')}}</span>
            <el-tooltip v-if="delayed_trips!=0"  :content="$t('SWITCHTO', {var : $t(!started_mode  ? 'ACTIVE' : 'DELAYED')})" placement="top">
           <el-badge class="trip-badge" :value="delayedCount" :hidden="!started_mode" v-if="delayed_trips!=0">
            <el-button  v-on:click="started_mode=!started_mode">
              <span v-text="$t(!started_mode ? 'ACTIVE' : 'DELAYED')"></span>
            </el-button>
            </el-badge>
            </el-tooltip>  
                          </div>

                            <div  v-loading="trip_loading" :element-loading-text="$t('LOADING')" style="height:340px">
                <VuePerfectScrollbar v-bind:style="{ height: '340px' }">          
                <el-button v-if="sortedTrips.length > 0" :disabled="trip.disabledTrip"  @click="goTo(trip.TripID)" type="text"  class="trip-box" :key="index"  v-for="(trip, index) in sortedTrips">
                <el-row style="padding:0 10px">
                  <el-col :span="showActivity(trip.activity) ? 2 : 4" class="busTag"><el-tag  type="primary"><i class="fa fa-bus"></i> {{trip.busNumber}} </el-tag></el-col>
                  <el-col :span="5" :align="alignDirection('right')" v-if="showActivity(trip.activity)" class="activity" @mouseover.native="trip.disabledTrip = true" @mouseleave.native="trip.disabledTrip = false">
                      <el-popover
                        trigger="hover"
                        :disabled="trip.activity.total_violations == 0"
                        :title="$t('TRIPVIOLATIONS')"
                        placement="right"
                        width="450"
                      >
                        <el-badge slot="reference" :value="trip.activity.total_violations" :max="6"><el-button size="mini"><i class="fa fa-tachometer"></i></el-button></el-badge>
                        <el-table
                            :data="arrayOfAlerts(trip.activity.violations)"
                            :empty-text="$t('NOVIOLATIONS')"
                            stripe
                            style="width: 100%"
                            >
                          <el-table-column label="Type" min-width="115">
                            <template slot-scope="scope">{{$t(scope.row.incident_type)}}</template>
                          </el-table-column>
                          <el-table-column min-width="185" label="Date">
                            <template slot-scope="scope">
                              <el-icon name="time"></el-icon>
                              <span style="margin-left: 5px">{{ activity_time(scope.row.Timestamp) }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column width="145" show-overflow-tooltip property="Text" label="Message"></el-table-column>
                        </el-table>                  
                      </el-popover>
                      <el-popover
                        popper-class="trip"
                        trigger="hover"
                        :disabled="trip.activity.total_alerts == 0"
                        :title="$t('TRIPALERTS')"
                        placement="right-start"
                        width="620"
                        >
                        <el-badge slot="reference" :value="trip.activity.total_alerts" :max="6"><el-button size="mini"><i class="fa fa-bell" aria-hidden="true"></i></el-button></el-badge>                   
                        <el-table 
                            :data="arrayOfAlerts(trip.activity.alerts)"
                            :default-sort="{prop: 'Sent', order: 'descending'}"
                            :empty-text="$t('NOALERTS')"
                            stripe
                            style="width: 100%"
                            >
                          <el-table-column width="85" :label="$t('TYPE')"><template slot-scope="scope">{{$t(scope.row.Event)}}</template></el-table-column>
                          <el-table-column width="130" :label="$t('OCCURED')">
                            <template slot-scope="scope">{{$t(scope.row.EventType)}}</template>
                          </el-table-column>
                          <el-table-column width="195" property="Sent" :label="$t('DATE')">
                            <template slot-scope="scope">
                              <el-icon name="time"></el-icon>
                              <span style="margin-left: 5px">{{ activity_time(scope.row.Sent) }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column show-overflow-tooltip :label="$t('MESSAGE')"><template slot-scope="scope">{{scope.row.Text ? scope.row.Text : '-'}}</template></el-table-column>
                          <el-table-column align="center" width="100"><template slot-scope="scope"><el-button v-if="scope.row.EntityID != null || scope.row.Event == 'INCIDENT'" size="mini" :loading="scope.row.EventID === sendingEvent" @click="activityInfo(scope.row, scope.$index)">{{$t('MOREINFO')}}</el-button></template></el-table-column>
                        </el-table>                  
                      </el-popover>
                  </el-col>                  
                  <el-col :span="showActivity(trip.activity) ? 11 : 14" align="center"><i class="fa fa-road fa-2x"></i> {{trip.TourName}}</el-col>
                  <el-col :span="6"  class="boardingTag">
                    <el-tag  type="primary"><i class="fa fa-user-circle"></i> <b  v-text="trip.Boarding"></b></el-tag>
                    <el-tag  type="primary" v-if="trip.IsClosed!=1"><i class="fa fa-map-marker"></i> {{nextStop(trip)}}</el-tag>
                    <el-tag  type="success" v-if="trip.IsClosed==1"><i class="fa fa-clock-o"></i> <b  v-text="trip.CompletedIn"></b> {{$t('MINUTES')}}</el-tag>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="2" align="center"><el-tooltip :disabled="trip.Db_Date == null" effect="light" :content="$t('STARTEDAT') + ' ' + tripTime(trip.timestamp)" placement="top"><i class="fa fa-2x" v-bind:class="[trip.Direction== 1 ? 'fa-home' : 'fa-university']"></i></el-tooltip></el-col>
                  <el-col :span="20" align="center">
                    <div class="el-progress el-progress--line el-progress--without-text" :class="[trip.Db_Date === null ? 'is-exception' : 'is-success']">
                      <div class="el-progress-bar">
                      <div class="el-progress-bar__outer" style="height: 18px;">
                        <div class="el-progress-bar__inner" v-if="trip.IsClosed!=1" v-bind:style="{ width: progressWidth(trip) + '%' }"></div>
                          <i v-if="trip.IsClosed!=1" class="fa fa-circle" v-bind:style="ballDirection(trip)"></i>
                          <div style="padding-top:2px" v-if="trip.IsClosed==1"> {{$t('TRIPCLOSED')}}</div>
                          <div style="padding-top:2px" v-if="trip.Db_Date === null"> {{$t('EXPECTEDTOSTART')}} <span class="delayed pull-right">{{$t('DELAYEDBY') + ' ' + delayed_time(trip)}}</span></div>                          
                      </div>

                      </div>
                    </div>
                  </el-col>
                  <el-col :span="2" align="center"><el-tooltip :disabled="trip.Db_Date == null" effect="light" :content="trip.IsClosed == 1 ? ($t('CLOSEDAT') + ' ' + tripTime(trip.UpdatedAt)) : $t('NOTCLOSINGYET')" placement="top"><i  class="fa fa-2x" v-bind:class="[trip.Direction!= 1 ? 'fa-home' : 'fa-university']"></i></el-tooltip></el-col>
                </el-row>
                <el-row style="padding:0 10px" v-if ="showCost(trip)">
                  <el-col :span="8"><el-tooltip :content="$t('FUELCOST') + ' ' + trip.TravelCost + ' ' + $t('AED')" position="bottom"><el-tag><i class="fa fa-money"></i> {{trip.TravelCost + ' ' + $t('AED')}} </el-tag></el-tooltip></el-col>
                  <el-col :span="8"><el-tooltip :content="$t('IDLECOST') +' ' + trip.IdleCost + ' ' + $t('AED')" position="bottom"><el-tag type="danger"><i class="fa fa-money"></i> {{trip.IdleCost + ' ' + $t('AED')}} </el-tag></el-tooltip></el-col>
                  <el-col :span="8"><el-tooltip :content="$t('TOTALCOST') +' ' + trip.TotalCost + ' ' + $t('AED')" position="bottom"><el-tag><i class="fa fa-money"></i> {{trip.TotalCost + ' ' + $t('AED')}} </el-tag></el-tooltip></el-col>                  
                </el-row>                
                </el-button>   
                <div v-if="sortedTrips.length==0" class="el-table__empty-block" style="width: 100%">
                  <span class="el-table__empty-text">{{$t('NODATA')}}</span>
                </div>
                </VuePerfectScrollbar>
          </div>
          <div style="padding: 10px; border-top:1px solid #ddd">
            <div class="bottom clearfix">
              <el-button type="primary" @click="viewMore('trip')">{{$t('VIEWMORE')}}</el-button>
            </div>
          </div>
        </el-card>
      </el-col>

    </el-row>
    <el-absence-dialog @update="updateAbsence" :data="absence" :selected-student="absence_student" :visible.sync="absenceBox"></el-absence-dialog>
    <el-message-dialog :visible.sync="messageBox"></el-message-dialog>
   <el-incident-dialog @deleteIncident="deleteIncident" :alert="notifyAlert" :incident="incident"  :visible.sync="incidentBox"></el-incident-dialog>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { EventBus } from '../event-bus.js'
  import IncidentDialog from '@/components/dialogs/Incident'
  import AbsenceDialog from '@/components/dialogs/Absence'
  import MessageDialog from '@/components/dialogs/Message'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  export default {
    name: 'Dashboard',
    components: {VuePerfectScrollbar, 'el-message-dialog': MessageDialog, 'el-absence-dialog': AbsenceDialog, 'el-incident-dialog': IncidentDialog},
    data () {
      return {
        incidents: [],
        incident: {incident_type: null, bus: {}, monitor: {}, Lat: null, Lng: null},
        messages: [],
        message: {text: null},
        violations: [],
        trips: {},
        students: {},
        absence_student: {},
        status: {0: 'success', 1: 'warning', 2: 'danger'},
        incident_loading: true,
        message_loading: true,
        violation_loading: true,
        absence_loading: true,
        trip_loading: true,
        dialogIncident: false,
        sendReport: false,
        messageBox: false,
        absenceBox: false,
        reportTo: null,
        channel: {},
        distance: 0,
        incidentBox: false,
        stops: {},
        total: 0,
        wiot_box: null,
        absence: {},
        absences: {'bus': [], 'school': []},
        absenceFrom: 'bus',
        prevIndex: 0,
        sendingEvent: null,
        notifyAlert: false,
        event: {},
        started_mode: true,
        delayed_trips: 0
      }
    },
    mounted () {
      this.switchLanguage()
      this.wiot_box = parseInt(localStorage.getItem('wiot_box'))
      this.getIncidents()
      this.getViolations()
      this.getMessages()
      this.getTrips()
      this.notificationEvents()
    },
    computed: {
      listAbsences () {
        return this.absences[this.absenceFrom]
      },
      listMessages () {
        let sorted = []
        let self = this
        Object.keys(this.messages).sort(function (a, b) {
          return self.messages[b].MessageID - self.messages[a].MessageID
        }).map(function (id, key) {
          if (key < 4) sorted.push(self.messages[id])
        })
        return sorted
      },
      delayedCount () {
        if (this.delayed_trips > 4) return '4+'
        return this.delayed_trips
      },
      sortedTrips () {
        let _trips = []
        if (_.isEmpty(this.trips)) return _trips
        let i = 0
        let trips = this.tripSort(this.trips)
        for (let trip in trips) {
          let TripID = parseInt(trips[trip])
          let _trip = null
          if (i === 4) break
          if (this.started_mode && this.trips[TripID].Db_Date !== null) {
            _trip = this.trips[TripID]
          }
          if (!this.started_mode && this.trips[TripID].Db_Date === null) {
            _trip = this.trips[TripID]
          }
          if (_trip !== null) {
            _trips.push(_trip)
            i++
          }
        }
        return _trips
      },
      reportStatus () {
        let reportStatus = {0: this.$t('RESOLVED'), 1: this.$t('REPORTED'), 2: this.$t('OPEN')}
        return reportStatus
      }
    },
    methods: {
      subscribeToBoarding (TripID) {
        this.$channel.bind('boarding-' + TripID, (boarding) => {
          EventBus.$emit('boarding', {TripID: TripID, data: boarding})
        })
      },
      arrayOfAlerts (alerts) {
        var results = []
        for (let key in alerts) {
          results.push(alerts[key])
        }
        return results
      },
      showCost (trip) {
        if (trip.Db_Date != null && trip.IsClosed === 1 && trip.TotalCost > 0) return true
        return false
      },
      showAbsence (absence) {
        if (_.isEmpty(absence)) return
        this.absence = _.pick(absence, ['AbsentID', 'StudentID', 'AbsentDate', 'Reason', 'OnlyFromBus', 'Trip', 'FromBMMA'])
        this.absence_student = _.pick(absence, ['StudentID', 'FullName_EN', 'FullName_AR', 'ImagePath'])
        this.absence.Completed = true
        this.absence.Excluded = false
        this.absenceBox = true
      },
      updateAbsence (data) {
        let absence = data[0]
        let absenceFrom = absence.OnlyFromBus ? 'bus' : 'school'
        if (!absence.Updated) return
        let absences = this.absences[absenceFrom]
        let self = this
        Object.keys(absences).map(function (key) {
          if (absences[key].AbsentDate === absence.AbsentDate) {
            self.absences[absenceFrom][key] = _.merge(absences[key], absence)
            self.updateDirection(self.absences[self.absenceFrom][key])
          }
        })
      },
      updateDirection (absence) {
        switch (absence.Trip) {
          case 1:
            absence.Direction.icon = 'morning-icon'
            absence.Direction.title = 'MORNINGBUS'
            break
          case 2:
            absence.Direction.icon = 'evening-icon'
            absence.Direction.title = 'AFTERNOONBUS'
            break
          case 3:
            absence.Direction.icon = 'from-bus'
            absence.Direction.title = 'NOBUS'
            break
        }
      },
      selectedConversation (currentRow, oldCurrentRow) {
        let BusMonitorID = currentRow.SenderID
        this.$router.push({path: '/report/message/' + BusMonitorID})
      },
      showActivity (activity) {
        if (activity.total_alerts !== 0 || activity.total_violations !== 0) return true
        return false
      },
      ballDirection (trip) {
        let direction = localStorage.getItem('lang') === 'en' ? 'left' : 'right'
        let css = {}
        let width = this.progressWidth(trip)
        // css[direction] = (this.progressWidth(trip) - 2) + '%'
        if (width === 100) css[direction === 'left' ? 'right' : 'left'] = 0 + '%'
        else css[direction] = width + (width > 2 ? (trip.Boarding === 0 ? 0 : -2) : 0) + '%'
        return css
      },
      date_format (date) {
        if (date === null) return
        return this.$moment(date).format('DD/MM/YYYY')
      },
      incident_date (date) {
        if (date === null) return
        return this.$moment(date).format('DD/MM/YYYY hh:mm')
      },
      tripSort (trips) {
        let dateSorted = Object.keys(trips).sort(function (a, b) {
          return trips[b].UpdatedAt - trips[a].UpdatedAt
        })
        if (this.started_mode) {
          return dateSorted.sort(function (a, b) {
            return trips[a].IsClosed - trips[b].IsClosed
          })
        } else {
          return dateSorted
        }
      },
      tripTime (time) {
        return this.$moment.unix(time, 'hh:mm A').format('hh:mm') + this.$moment.unix(time, 'hh:mm A').locale(localStorage.getItem('lang')).format(' A')
      },
      notificationEvents () {
        EventBus.$on('incident', incident => {
          if (this.trips[incident.TripID] !== undefined) {
            this.trips[incident.TripID].UpdatedAt = this.$moment().unix()
            let obj = {}
            obj.Event = 'INCIDENT'
            obj.EntityID = null
            obj.EventID = incident.incident_id
            obj.EventType = incident.incident_type
            obj.Sent = incident.Timestamp
            obj.Text = incident.Text
            if (this.trips[incident.TripID].activity.alerts[incident.incident_id] === undefined) {
              this.trips[incident.TripID].activity.alerts[incident.incident_id] = obj
              this.trips[incident.TripID].activity.total_alerts++
            }
          }
          this.incidents.unshift(incident)
          if (this.incidents.length > 4) this.incidents.pop()
        })
        EventBus.$on('violation', violation => {
          this.violations.unshift(violation)
          // if (this.violations.length > 4) this.violations.pop()
        })
        EventBus.$on('message', message => {
          this.$set(this.messages, message.SenderID, message)
        })
        EventBus.$on('trip', trip => {
          let IsClosed = trip.IsClosed
          if (this.trips[trip.TripID] !== undefined) {
            if (trip.Expected) {
              this.trips[trip.TripID].Db_Date = (trip.Db_Date === undefined) ? null : trip.Db_Date
              this.trips[trip.TripID].BusDriverID = (trip.BusDriverID === undefined) ? null : trip.BusDriverID
              this.trips[trip.TripID].BusMonitorID = (trip.BusMonitorID === undefined) ? null : trip.BusMonitorID
            }
            this.total--
            this.trips[trip.TripID].UpdatedAt = trip.UpdatedAt
            if (trip.IsCancelled === 1) {
              if (trip.NewTripID !== undefined) {
                this.trips[trip.TripID].TripID = trip.NewTripID
                this.trips[trip.TripID].Boarding = 0
                this.trips[trip.TripID].checked_stop = 0
                this.assignNewTrip(this.trips[trip.TripID])
                this.$delete(this.stops, trip.TripID)
              }
              this.$delete(this.trips, trip.TripID)
            } else {
              if (trip.TotalCost !== undefined) {
                this.trips[trip.TripID].TotalCost = trip.TotalCost
                this.trips[trip.TripID].TravelCost = trip.TravelCost
                this.trips[trip.TripID].VehicleCost = trip.TotalCost
                this.trips[trip.TripID].IdleCost = trip.IdleCost
              }
              this.trips[trip.TripID].CompletedIn = trip.CompletedIn
              this.trips[trip.TripID].IsClosed = IsClosed
            }
            return
          }
          if (trip.IsClosed === 1) return
          this.total++
          this.assignNewTrip(trip)
        })
        EventBus.$on('alert', alert => {
          if (this.trips[alert.TripID] === undefined) return
          this.trips[alert.TripID].UpdatedAt = this.$moment().unix()
          if (this.trips[alert.TripID].activity.alerts[alert.EventID] === undefined) {
            this.trips[alert.TripID].activity.alerts[alert.EventID] = alert
            this.trips[alert.TripID].activity.total_alerts++
          }
        })
        EventBus.$on('boarding', boarding => {
          let TripID = boarding.TripID
          let _bording = Object.assign({}, boarding.data)
          if (_bording.IsMissing !== undefined) return
          if (_bording.CheckOut === undefined) this.trips[TripID].Boarding = _bording.Boarding
          if (_bording.CheckOut !== undefined) this.trips[TripID].checked_out = _bording.CheckOut
          if (this.trips[TripID].Direction === 1 && _bording.CheckOut !== undefined) _bording.Stop = this.trips[TripID].student_stops
          this.trips[TripID].checked_stop = parseInt(_bording.Stop)
        })
      },
      assignNewTrip (trip) {
        let obj = {}
        obj[trip.TripID] = trip
        this.trips = Object.assign(obj, this.trips)
        this.stopsPoint(trip)
      },
      readMore (text) {
        if (text.length <= 60) return text
        let textCut = text.substring(0, 50)
        let spaces = textCut.split(' ')
        spaces.pop()
        let newText = spaces.join(' ')
        return newText + '.....'
      },
      getIncidents () {
        let self = this
        this.$http.get('/incident?ref=dashboard&limit=5&offset=0&flagged=1').then(function (response) {
          self.incidents = _.isEmpty(response.data.incidents) ? [] : response.data.incidents
          self.incident_loading = false
        }).catch(function (response) {
          self.incident_loading = false
        })
      },
      getMessages () {
        let self = this
        this.$http.get('/message?ref=dashboard&limit=4&offset=0').then(function (response) {
          self.messages = !response.data ? [] : response.data
          self.message_loading = false
        }).catch(function (response) {
          self.message_loading = false
        })
      },
      getViolations () {
        let self = this
        if (this.wiot_box !== 1) return this.getAbsences()
        this.$http.get('/violation?ref=dashboard&limit=5&offset=0').then(function (response) {
          self.violations = _.isEmpty(response.data.violations) ? [] : response.data.violations
          self.violation_loading = false
          self.absence_loading = false
        }).catch(function (response) {
          self.violation_loading = false
          self.absence_loading = false
        })
      },
      getTrips () {
        let self = this
        this.$http.get('/trip?ref=dashboard&limit=4&offset=0&key=1').then(function (response) {
          self.total = Object.keys(response.data).length
          if (self.total === 0) return (self.trip_loading = false)
          let trips = response.data.trips
          for (let trip in trips) {
            self.stopsPoint(trips[trip])
            self.$set(self.trips, trip, trips[trip])
            EventBus.boarding[trip] = trips[trip].Boarding
            if (trips[trip].IsClosed === 0) self.subscribeToBoarding(trip)
          }
          self.delayed_trips = response.data.total_pending
          self.trip_loading = false
        }).catch(function (response) {
          self.trip_loading = false
        })
      },
      getAbsences () {
        let self = this
        if (self.absences[self.absenceFrom].length !== 0) return
        this.$http.get('/absence?ref=dashboard&type=' + self.absenceFrom + '&limit=5&offset=0').then(function (response) {
          self.$set(self.absences, self.absenceFrom, response.data.absences)
          self.absence_loading = false
          self.violation_loading = false
        }).catch(function (response) {
          self.absence_loading = false
          self.violation_loading = false
        })
      },
      switchTo () {
        this.absenceFrom = this.absenceFrom === 'bus' ? 'school' : 'bus'
        this.getAbsences()
      },
      progressWidth (trip) {
        let stop = trip.checked_stop
        if (trip.skip_stops < stop) stop -= trip.skip_stops
        if (stop === 0 || trip.IsClosed === 1) return 0
        if (trip.Direction === 2 && trip.checked_out == null) return 0
        if (trip.Direction === 1 && trip.checked_out !== null) stop = trip.student_stops + 1
        return this.stops[trip.TripID].sizes[stop - 1]
      },
      nextStop (trip) {
        let num = 1
        let stop = trip.checked_stop
        if (trip.skip_stops < stop) stop -= trip.skip_stops
        if (trip.Direction === 2 && trip.checked_out !== null) num = 0
        if (stop === 0 || (trip.Direction === 2 && trip.checked_out === null)) return this.$t('FIRSTSTOP')
        if (trip.Direction === 1 && trip.checked_out !== null) return this.$t('SCHOOL')
        if (stop !== this.stops[trip.TripID].sizes.length - num) return this.$t('NEXTSTOP') + ' ' + (stop + 1)
        if (stop === this.stops[trip.TripID].sizes.length) return this.$t('LASTSTOP')
        return trip.Direction === 1 && this.trips[trip.TripID].checked_out !== null ? this.$t('SCHOOL') : this.$t('NOMORESTOPS')
      },
      stopsPoint (trip) {
        if (this.stops[trip.TripID] !== undefined) return
        let points = []
        let distance = 0
        let percentage = null
        if (trip.IsClosed === 1) return 0
        let stops = trip.stops
        for (let stop in stops) {
          distance += parseInt(stops[stop].Distance)
          points.push(distance)
        }
        distance = parseFloat(distance / 1000).toFixed(2)
        if (trip.Direction === 1) distance *= 2
        let sizes = []
        for (let item in points) {
          let value = parseFloat(points[item] / 1000).toFixed(2)
          percentage = (value * 100) / distance
          sizes.push(percentage)
        }
        if (trip.Direction === 1) sizes.push(100)
        this.stops[trip.TripID] = {sizes: sizes, checked_stop: trip.checked_stop, Direction: trip.Direction}
      },
      showMessageModal (student) {
        this.messageBox = true
        this.student = student
      },
      goTo (TripID) {
        this.$router.push({path: '/report/trip/' + TripID})
      },
      showIncident (incident) {
        this.incident = incident
        this.incidentBox = true
      },
      hideItem (item, index, type) {
        item.IsHidden = !item.IsHidden
        let idName = _.startCase(_.toLower(type)) + 'ID'
        let postData = {id: item[idName], type: 'hidden', flag: item.IsHidden ? 1 : 0, name: type}
        let self = this
        this.$http.post('/report/flag', postData).then(function (response) {
          if (item.IsHidden) (type === 'violation') ? self.violations.splice(index, 1) : self.messages.splice(index, 1)
        }).catch(function (response) {})
      },
      flagItem (item, index, type) {
        item.IsSticky = !item.IsSticky
        let idName = (type === 'incident') ? 'incident_id' : 'ViolationID'
        let self = this
        let postData = {id: item[idName], type: 'sticky', flag: item.IsSticky ? 1 : 0, name: type}
        this.$http.post('/report/flag', postData).then(function (response) {
          if (type === 'incident') {
            if (item.statusColor === 0 && item.IsSticky === false) self.getIncidents()
          }
        }).catch(function (response) {})
      },
      deleteIncident (incident) {
        if (incident.statusColor === 0 && incident.show) this.getIncidents()
      },
      viewMore (path) {
        let target = '/report/'
        switch (path) {
          case 'message':
            EventBus.messages.total = 0
            break
          case 'incident':
            EventBus.incidents.total = 0
            break
          case 'violation':
            EventBus.violations.total = 0
            break
          case 'absence':
            target = '/attendance/'
            break
        }
        target += path
        this.$router.push(target)
      },
      delayed_time (trip) {
        let time = (trip.Direction === 1) ? trip.Time_AM_In : trip.Time_PM_In
        time = time.split(':')
        let display = ''
        let diff = this.$moment().subtract({hours: time[0], minutes: time[1]})
        if (diff.hour() > 0) display += diff.hour() + this.$tc('HOUR', (diff.hour() === 1 ? 1 : 2))
        if (diff.hour() > 0 && diff.minute() > 0) display += ','
        if (diff.minute() > 0) display += diff.minute() + this.$tc('MINUTE', (diff.minute() === 1 ? 1 : 2))
        this.$root.$children[0].TIME
        return display
      },
      activity_time (date) {
        return this.$moment(date).format('MM-DD-YYYY, h:mm a')
      },
      activityInfo (obj, index) {
        this.notifyAlert = (obj.Event === 'ALERT')
        if (obj.data !== undefined) {
          this.incident = obj.data
          this.incidentBox = true
          return
        }
        this.sendingEvent = obj.EventID
        let self = this
        this.eventResource(obj.EventID, this.notifyAlert).then(function (result) {
          self.sendingEvent = null
          let StudentID = result.data.student_id
          if (self.notifyAlert) {
            result.data.student_id = []
            result.data.student_id.push(StudentID)
          }
          self.incident = obj.data = result.data
          self.incidentBox = true
        }).catch(function () { self.sendingEvent = null })
      },
      eventResource (EventID, alert) {
        return this.$http.get('/incident/event_info?EventID=' + EventID + '&IsAlert=' + alert)
      }
    }
  }
</script>

<style>
  .dashboard{padding:20px ;}
  .dashboard .el-card{margin-bottom: 20px !important;}
  .dashboard .bottom{text-align: center}
  .incident, .transport,  .violation,   .message{border-radius:4px !important}
  .incident .el-table th > .cell, .violation .el-table th > .cell{color:#4b4b4b; background: none}
   .incident .el-table th , .violation .el-table th {background-color: rgba(75, 75, 75, 0.1) !important; }
  .incident .el-card__header{background-color: #f4897c !important;}
  .message  .el-card__header{    background-color: #b6b5b3 !important;border-color:#f4dd93 }
  .violation  .el-card__header{background-color: #f4dd93 !important}
  .transport .el-card__header{    background-color: #f5c838 !important;}
  .el-table{ min-height:290px}
  .media{padding:5px 0}
  .incident .el-table td, .violation .el-table td{padding:5px 0}
  .message table thead, .transport table thead{display: none  !important;}
  .el-progress-bar{margin-top:5px}
  .el-progress-bar__outer{background-color: #4b4b4b}
  .el-progress-bar .fa{position:absolute;color:#f5c838; font-size: 19px}
  .transport .el-table--striped .el-table__body {height:100% !important;}
  .transport .el-table td{padding:10px 0}
  .el-card__body{position: relative}
  .incident_dialog .el-dialog__body{padding:15px 0}
  .message td{padding:0;}
  .el-table td{font-size:13px}
  .message .el-card__header .el-button{float:right}
  #rtl .message .el-card__header .el-button{float:left}
  .dashboard .el-badge.el-tooltip {float:right; margin-top:-1px}
 .dashboard .el-badge {float:right;}
  .dashboard .el-card__header .el-badge sup{margin:5px}
  #rtl .dashboard .el-badge  {float:left}
  .trip-badge .el-badge__content {padding: 0 4px;}
  .pointer-hover:hover{cursor: pointer;}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?c14ad68a